import { Pipe, PipeTransform } from '@angular/core';
import { Constants } from '../constants';
import { vsprintf } from 'sprintf-js';
import { TranslationsService } from '../services/translations/translations.service';

@Pipe({
  name: 'translate',
  pure: false
})
export class TranslatePipe implements PipeTransform {
  /**
   * Translations object
   * @var {object}
   */
  private readonly _translations: object = {};

  /**
   * Class constructor
   *
   * @param _translationsService Local instance of Translations service
   */
  constructor(
      private _translationsService: TranslationsService
  ) {
    this._translations = this._translationsService.getTranslations();
  }

  /**
   * Translate key and fill placeholders
   * @param {string} key The translation key
   * @param {Array<string | number>} content Content to replace placeholders with if applicable
   *
   * @returns {string} The translated key with placeholders filled
   */
  public transform(key: string, content?: Array<string | number>): string {
    key = this._buildTranslationKey(key);

    let translatedString = key;

    if (this._translations.hasOwnProperty(key)) {
      translatedString = this._translations[key];

      if (!!content && !!content.length) {
        translatedString = vsprintf(translatedString, content);
      }
    }

    return translatedString;
  }

  private _buildTranslationKey(key: string): string {
    return `${Constants.RESOURCE_BUNDLE_PREFIX}${key.trim()}`;
  }
}
